// src/Lexbuild/AgentForm.jsx
import React, { useState, useEffect } from "react";
import { generateWorkflowFromSchema } from "./AgentSync";

export default function AgentForm({ initialData, onSave, onCancel }) {
  const [form, setForm] = useState({
    name:        "",
    type:        "",
    description: "",
    public:      false,
  });
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    if (initialData) {
      // hydrate form fields
      setForm({
        name:        initialData.name || "",
        type:        initialData.type || "",
        description: initialData.description || "",
        public:      !!initialData.public,
      });
    }
  }, [initialData]);

  const handleChange = (field, value) =>
    setForm((f) => ({ ...f, [field]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.type.trim()) {
      return alert("Name & Type are required");
    }
    // just metadata → switch to Workflow tab
    onSave({ ...form });
  };

  const handleGenerate = async () => {
    if (!form.name.trim() || !form.type.trim()) {
      return alert("Fill in Name & Type before auto-generating");
    }
    setGenerating(true);
    try {
      // call your LLM to get a graph JSON: { nodes: [...], edges: [...] }
      const graphJson = await generateWorkflowFromSchema(form);
      // derive the simple workflow array from its nodes
      const wf = Array.isArray(graphJson.nodes)
        ? graphJson.nodes.map((n) => ({ step: n.type, params: { ...n.data } }))
        : [];
      // push everything up: metadata + graph
      onSave({
        ...form,
        workflow: wf,
        nodes:    graphJson.nodes || [],
        edges:    graphJson.edges || [],
      });
    } catch (err) {
      console.error(err);
      alert("Failed to generate workflow: " + err.message);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="lb-form">
      <label>
        Name<span>*</span>
        <input
          type="text"
          value={form.name}
          onChange={(e) => handleChange("name", e.target.value)}
          required
        />
      </label>

      <label>
        Type<span>*</span>
        <input
          type="text"
          value={form.type}
          onChange={(e) => handleChange("type", e.target.value)}
          required
        />
      </label>

      <label>
        Description
        <textarea
          value={form.description}
          onChange={(e) => handleChange("description", e.target.value)}
        />
      </label>

      <label className="lb-toggle">
        <input
          type="checkbox"
          checked={form.public}
          onChange={(e) => handleChange("public", e.target.checked)}
        />
        Public
      </label>

      <div className="lb-form-footer">
        <button
          type="button"
          onClick={handleGenerate}
          className="lb-secondary-btn"
          disabled={generating}
        >
          {generating ? "Generating…" : "🪄 Generate Workflow"}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="lb-secondary-btn"
        >
          Cancel
        </button>
        <button type="submit" className="lb-primary-btn">
          Next → Workflow
        </button>
      </div>
    </form>
  );
}
